import React, { useRef, useState, useEffect } from "react";
import { motion, useInView } from "framer-motion";
import Lightbox from "./SubComponents/Lightbox";


import Foto1 from "../Cabañas/Foto1.png";
import Foto2 from "../Cabañas/Foto2.png";
import Foto3 from "../Cabañas/Foto3.png";
import Foto4 from "../Cabañas/Foto4.png";
import Foto5 from "../Cabañas/Foto5.jpg";
import Foto6 from "../Cabañas/Foto6.jpg";

const fila1 = [Foto1, Foto2, Foto3, Foto4, Foto5, Foto6];
const fila2 = [Foto4, Foto5, Foto1, Foto6, Foto2, Foto3];

const FADE_WIDTH = "120px";

function useCarrusel(trackRef, speed) {
  const pausedRef = useRef(false);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    track.innerHTML += track.innerHTML;
    const total = track.scrollWidth / 2;
    let pos = speed < 0 ? total : 0;
    const fila = track.parentElement;
    const pause  = () => { pausedRef.current = true;  };
    const resume = () => { pausedRef.current = false; };
    fila.addEventListener("mouseenter", pause);
    fila.addEventListener("mouseleave", resume);
    const tick = () => {
      if (!pausedRef.current) {
        pos += speed;
        if (pos >= total) pos = 0;
        if (pos < 0)      pos = total;
        track.style.transform = `translateX(-${pos}px)`;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
    return () => {
      fila.removeEventListener("mouseenter", pause);
      fila.removeEventListener("mouseleave", resume);
    };
  }, []);
}

const FilaCarrusel = ({ fotos, speed, onImageClick }) => {
  const trackRef = useRef(null);
  useCarrusel(trackRef, speed);

  const handleClick = (e) => {
    const item = e.target.closest("[data-index]");
    if (item && onImageClick) onImageClick(fotos, parseInt(item.dataset.index));
  };

  return (
    <div className="relative w-full overflow-hidden">
      <div className="absolute left-0 top-0 bottom-0 w-[20px] md:w-[120px] z-10 pointer-events-none"
        style={{  background: "linear-gradient(to right, #fff, transparent)" }} />
      <div className="absolute right-0 top-0 bottom-0  w-[20px] md:w-[120px] z-10 pointer-events-none"
        style={{  background: "linear-gradient(to left, #fff, transparent)" }} />
      <div ref={trackRef} className="flex gap-3 w-max" onClick={handleClick}>
        {fotos.map((src, i) => (
          <div key={i} data-index={i} className="h-[220px] flex-shrink-0 rounded-[14px] overflow-hidden group cursor-zoom-in relative">
            <img
              src={src}
              alt={`Foto ${i + 1}`}
              className="h-full w-auto block transition-transform duration-500 group-hover:scale-105"
              draggable={false}
            />
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-black/15 pointer-events-none">
              <div className="bg-black/40 backdrop-blur-sm border border-white/30 rounded-full w-9 h-9 flex items-center justify-center">
                <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" className="w-4 h-4">
                  <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/><path d="M11 8v6M8 11h6"/>
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Galeria = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.3 });
  const [phase, setPhase] = useState("hidden");
  const [lightbox, setLightbox] = useState(null); // { index }

  const allPhotos = fila1;

  const handleImageClick = (photos, idx) => {
    setLightbox({ photos, index: idx });
  };

useEffect(() => {
  if (isInView) {
    setPhase("small");
  } else {
    setPhase("hidden");
  }
}, [isInView]);

  return (
    <section
    id="Fotos"
    ref={ref} 
    className="h-[100dvh] snap-start overflow-hidden relative bg-white flex flex-col items-center justify-center gap-6">

  
    <div className=" md:max-h-[65dvh] max-h-[85dvh] w-[90%] md:w-[75%] max-w-5xl mx-auto flex flex-col items-center justify-center gap-6">
  {/* Título */}
  <motion.div
    className="z-10 text-center"
    animate={phase === "small" ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
    
    transition={{ duration: 0.5, ease: "easeInOut" }}
  >
    <p className="text-xs tracking-[0.22em] text-[#F55809] uppercase font-sans mb-1 ">
          Galeria
        </p>
    <h1 className="titulo-playfair font-bold italic text-[#7D6239] text-[2rem]">
      ¿Te quedaste con ganas de ver más?
    </h1>
    <div className="h-[5px]  w-[3rem] mx-auto rounded-full bg-gradient-to-r from-[#CC2329] to-[#F55809] mt-2" />
  </motion.div>

  {/* Filas */}
  <motion.div
    className="relative z-10 w-full flex flex-col gap-3"
    animate={phase === "small" ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
    transition={{ duration: 0.7, ease: "easeOut", delay: 0.2 }}
  >
    <FilaCarrusel fotos={fila1} speed={0.6}  onImageClick={handleImageClick} />
    <FilaCarrusel fotos={fila2} speed={-0.5} onImageClick={handleImageClick} />
  </motion.div>
  </div>

      {lightbox && (
        <Lightbox
          photos={lightbox.photos}
          index={lightbox.index}
          onClose={() => setLightbox(null)}
          onPrev={() => setLightbox(l => ({ ...l, index: l.index === 0 ? l.photos.length - 1 : l.index - 1 }))}
          onNext={() => setLightbox(l => ({ ...l, index: l.index === l.photos.length - 1 ? 0 : l.index + 1 }))}
        />
      )}
</section>
  );
};

export default Galeria;